import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { TabBar, TabItem } from '@offerzen/pinata-shame'

import styles from './styles'

const SubNav = ({ navItems }) => {
  return (
    <div className={styles.wrapper}>
      <TabBar>
        <For each="item" of={navItems}>
          <TabItem key={item.href} href={item.href} label={item.label} theme="primary" asLink={NavLink} />
        </For>
      </TabBar>
    </div>
  )
}

SubNav.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

export default SubNav
